import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes with later ones winning conflicts.
 *
 * The standard shadcn/ui helper. Every component uses it so a caller can override a utility
 * without fighting specificity — which is what keeps §4.8's "Tailwind only" rule liveable.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
